<template>
  <modal
    class="POSModal overflow-y-auto"
    name="POSModal"
    transition="pop-out"
    :width="modalWidth"
    :height="600"
    @opened="opened"
  >
    <div>
      <div class="full__row_section mb-5">
        <div class="pos_modal ml-3">
          <div
            class="row align-items-center p-2"
            v-if="modalDataValues.branchName"
          >
            <div class="col-md-6 label_text">
              <label> {{ $t("text.posModal.branchName") }} </label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.branchName }}</label>
              </div>
            </div>
          </div>
          <div
            class="row align-items-center p-2"
            v-if="modalDataValues.cashBack"
          >
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.transactionType") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ $t("text.posModal.cashBack") }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.transactionDate") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  this.$moment(modalDataValues.paymentDate).format("YYYY-MM-DD")
                }}</label>
              </div>
            </div>
          </div>
          <div
            class="row align-items-center p-2"
            v-if="!modalDataValues.cashBack"
          >
            <div class="col-md-6 label_text">
              <label> {{ $t("text.posModal.pumpName") }} </label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input" v-if="modalData && modalData.pumpName">
                <label for="">{{ modalData.pumpName ? modalData.pumpName: " " }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label> {{ $t("text.posModal.amount") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">₦ {{ modalDataValues.amount }}</label>
              </div>
            </div>
          </div>
          <div
            class="row align-items-center p-2"
            v-if="modalDataValues.cashBack"
          >
            <div class="col-md-6 label_text">
              <label> {{ $t("text.posModal.charge") }} </label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">₦ {{ modalDataValues.charge }}</label>
              </div>
            </div>
          </div>

          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.transactionRef") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.transactionReference }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.stan") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.stan }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.RRN") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{
                  modalDataValues.retrievalReferenceNumber
                }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.maskedPan") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.maskedPan }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.customerName") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.customerName }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.status") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.statusDescription }}</label>
              </div>
            </div>
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.cardExpiry") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for=""
                  >{{
                    modalDataValues.cardExpiry
                      ? modalDataValues.cardExpiry.slice(2)
                      : null
                  }}/{{
                    modalDataValues.cardExpiry
                      ? modalDataValues.cardExpiry.slice(0, 2)
                      : null
                  }}</label
                >
              </div>
            </div>
            <!-- paymentDate -->
          </div>
          <div class="row align-items-center p-2">
            <div class="col-md-6 label_text">
              <label>{{ $t("text.posModal.terminalId") }}</label>
            </div>
            <div class="col-md-6 mobile_resp">
              <div class="details_input">
                <label for="">{{ modalDataValues.terminalId }}</label>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              class="save__btn record_expense_btn btn_primary_color w-50"
              @click="()=>downloadReceipt(modalData.id)"
            >
              {{ $t("text.clickButtons.download") }}
              <span
                ><img
                  src="/img/git_loader.8264c9b1.gif"
                  width="25px"
                  class="loader ml-2"
                  style="display: none"
              /></span>
            </button>
          </div>
        </div>
      </div>
      <!-- //START OF POS RECEIPT TEMPLATE -->
      <div
        style="
          font-size: 16px;
          max-width: 465px;
          font-family: 'Times New Roman', Times, serif;
          display: none;
        "
        id="printContent"
      >
        <p
          style="
            text-align: center;
            align-content: center;
            margin-top: 30px;
            font-weight: bold;
            font-family: Arial, Helvetica, sans-serif;
          "
        >
          {{ $t("text.posModal.providusBank") }}
        </p>
        <p style="margin: 0">
          {{ $t("text.posModal.merchantName") }} <br />
          {{ modalDataValues.branchName }}
        </p>
        <p style="margin: 0">
          {{ modalDataValues.branchAddress }}<br />
          {{ $t("text.posModal.terminalID") }} {{ modalDataValues.terminalId }}
        </p>
        <p style="margin: 0; text-align: center">
          ---------------------------------------------
        </p>
        <h5 style="text-align: center; align-content: center; margin: 0">
          {{ $t("text.posModal.reprint") }}
        </h5>
        <p
          style="
            text-align: center;
            align-content: center;
            margin: 6px 0;
            transform: scale(1, 1.9);
            text-transform: uppercase;
          "
        >
          {{ modalDataValues.type }}
        </p>
        <p style="margin: 0">
          {{ $t("text.posModal.STAN") }} {{ modalDataValues.stan }}
        </p>
        <p style="margin: 0">
          {{ $t("text.posModal.dateTime") }} {{ modalDataValues.paymentDate }}
        </p>
        <p style="margin: 0; text-align: center">
          ----------------------------------------------
        </p>
        <p style="margin: 0">
          {{ $t("text.posModal.amount") }}
          <span
            style="float: right; margin-right: 20px; transform: scale(1, 1.4)"
            >NGN {{ modalDataValues.amount }}.00</span
          >
        </p>
        <p style="margin: 0; text-align: center">
          ----------------------------------------------
        </p>
        <h6
          style="
            margin: 0;
            text-align: center;
            align-content: center;
            font-size: 20px;
          "
        >
          {{ modalDataValues.maskedPan }}
        </h6>
        <p style="margin: 0">
          {{ $t("text.posModal.expiryDate") }}
          {{
            modalDataValues.cardExpiry
              ? modalDataValues.cardExpiry.slice(2)
              : null
          }}/{{
            modalDataValues.cardExpiry
              ? modalDataValues.cardExpiry.slice(0, 2)
              : null
          }}
        </p>
        <p style="margin: 0; text-align: center">
          ----------------------------------------------
        </p>
        <h4 style="margin: 0; font-size: 14px">
          {{ modalDataValues.statusDescription }}
        </h4>
        <p style="margin: 0">
          {{ $t("text.posModal.responseCode") }}
          {{ modalDataValues.statusCode }}
        </p>
        <p style="margin: 0">
          {{ $t("text.posModal.refNumber") }}
          {{ modalDataValues.retrievalReferenceNumber }}
        </p>
        <p style="margin: 0">{{ modalDataValues.vendor }}</p>
        <p style="margin: 0; text-align: center">
          ----------------------------------------------
        </p>
        <p
          style="
            text-align: center;
            margin-right: 20px;
            font-weight: bold;
            font-size: 14px;
            margin: 0;
            padding-bottom: 40px;
          "
        >
          {{ $t("text.posModal.merchantCopy") }} <br />
          {{ $t("text.posModal.pumpAuth") }}
        </p>
      </div>
      <!-- //END OF POS RECEIPT TEMPLATE -->
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "POSModal",
  props: ["modalData"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {

    downloadReceipt(id) {
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios({
        url: `${configObject.apiBaseUrl}/Pos/TransactionReceipt/${id}`,
        method: "GET",
        headers: configObject.authConfig().headers,
        responseType: "blob",
      })
        .then((response) => {
          const blob = response.data;
          let disposition = response.headers["content-disposition"];
          let depositionArr = disposition.split(";")[1];
          const fname = depositionArr
            .split("=")[1]
            .split("_")
            .join("_")
            .replace(/["']/g, "");
          this.savePdfFile(blob, fname);

          this.$toast.open({
            message: this.$t("text.omit.successfullyDownloaded"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;

          // this.isButtonDisabled = false;
          // $(".loader").hide();
        })
        .catch((error) => {
          // this.isButtonDisabled = false;
          // $(".loader").hide();

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },

    savePdfFile(blob, filename) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE browser
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    },

    print() {
      // this.closeModal()
      // this.$eventHub.$emit('PrintPos')
      var elementHTML = $("#printContent").html();
      //  window.open(window.href, '_blank').focus()
      //   window.open('', '','width=1000,height=700')
      var myWindow = window.open("", "", "width=800,height=700");
      myWindow.document.write(elementHTML);
      var style = myWindow.document.createElement("style");
      style.innerHTML = `
        @page {
          size: auto;  /* auto is the initial value */
          margin: 0mm; /* this affects the margin in the printer settings */
          margin-right: 10px;
        }
        html {
          background-color: #FFFFFF;
          margin: 0px; /* this affects the margin on the HTML before sending to printer */
        }
        body {
          margin: 10mm 15mm 10mm 15mm; /* margin you want for the content */
          margin: 0mm;
          padding:15px 0px;
          font-size: 11px;
           font-family: "Times New Roman", Times, serif;
          /*  transform: scale(1, 1.5);*/
          /*  margin-top: 10em;*/
}
        }
        
        `;
      myWindow.document.head.appendChild(style);
      myWindow.document.close();
      myWindow.focus();
      myWindow.print();
      // myWindow.close();
    },

    closeModal() {
      this.$modal.hide("POSModal");
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    opened() {
      this.modalDataValues = this.modalData;
      if (!this.modalData.pumpName) {
        JSON.parse(this.modalData.additionalInformation).forEach((cur) => {
          if (cur.Name == "PumpName") {
            this.pumpName = cur.Value;
          }
        });
      } else {
        this.pumpName = this.modalData.pumpName;
      }
    },
  },
};
</script>
